export const ADD_TO_HISTORY = 'add to history';
